import { properCase } from "LIB/formatters/text";
import { arrayToManipulatedOptions } from "LIB/forms";
import { removeItems } from "LIB/arrays";
import { subroleLabel } from "./helpers";

export const USER = "user";

export const AIRLINE_SERVICES_NOTIFICATION = "airline_services_notification";
export const AS_IS = "as_is";
export const ACTIVE = "active";
export const BOOKMARKS = "bookmarks";
export const BUYING_LIMIT = "buying_limit";
export const BUYER_ID = "buyer_id";
export const CACHED_SALES_CART = "cachedSalesCart";
export const CAN_ADD_COMPANIES = "can_add_companies";
export const CAN_UPDATE_COMPANIES = "can_update_companies";
export const CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS =
  "can_delete_receiving_record_attachments";
export const CAN_EDIT_DO_NOT_EXCHANGE = "can_edit_do_not_exchange";
export const CAN_OVERRIDE_LISTING = "can_override_listing";
export const CAN_RELEASE_SHIPMENT = "can_release_shipment";
export const CAN_RELEASE_ACCOUNTING_HOLD = "can_release_accounting_hold";
export const CAN_RELEASE_CORE_RETURN = "can_release_core_return";
export const CO_BUYER = "co_buyer";
export const CO_BUYER_ID = "co_buyer_id";
export const COMMISSION_CREDIT_PERCENT = "commission_credit_percent";
export const EMAIL = "email";
export const EMAIL_VERIFIED = "email_verified";
export const EXPORT_LIMIT = 1875;
export const RELEASE_EXPORT_COMPLIANCE_HOLD = "release_export_compliance_hold";
export const REPAIR_CART_ITEMS = "repairCartItems";
export const SALES_CART_ITEMS = "salesCartItems";
export const TEAM_LEADER_CREDIT_PERCENT = "team_leader_credit_percent";
export const TEAM_LEADER_COMMISSION_ENABLED = "team_leader_commission_enabled";
export const TEAM_MEMBERS = "team_members";
export const THIRD_BUYER = "third_buyer";
export const THIRD_BUYER_ID = "third_buyer_id";
export const USER_ID = "user_id";
export const EXCHANGE_COMMISSIONS = "exchange_commissions";
export const FIRST_NAME = "first_name";
export const FULL_NAME = "full_name";
export const ID = "id";
export const LAST_NAME = "last_name";
export const MANAGER = "manager";
export const ROLE = "role";
export const NOTIFICATION_ROLES = "notification_roles";
export const PERMISSIONS = "permissions";
export const REPAIR_ORDER_CART_ITEMS = "repair_order_cart_items";
export const RESET_PASSWORD_TOKEN = "reset_password_token";
export const SALES_ORDER_CART_ITEMS = "sales_order_cart_items";
export const SUBROLE = "subrole";
export const HIGH_CONFIDENCE_BUYER = "high_confidence_buyer";

export const ADMIN = "admin";
export const ACCOUNTING = "accounting";
export const BUYER = "buyer";
export const QUALITY_CONTROL = "quality_control";
export const SALES = "sales";
export const REPAIR = "repair";
export const REPAIRS = "repairs";
export const WAREHOUSE = "warehouse";

export const ACCOUNTING_ADMIN = "accounting_admin";
export const ACCOUNTING_MANAGER = "accounting_manager";
export const BUYER_MANAGER = "buyer_manager";
export const PURCHASING = "purchasing";
export const PURCHASING_MANAGER = "purchasing_manager";
export const QUALITY_CONTROL_MANAGER = "quality_control_manager";
export const QUALITY_CONTROL_EXPEDITOR = "quality_control_expeditor";
export const QUALITY_CONTROL_ADMIN = "quality_control_admin";
export const SALES_MANAGER = "sales_manager";
export const WAREHOUSE_BASIC = "warehouse_basic";
export const WAREHOUSE_EXPERT = "warehouse_expert";
export const WAREHOUSE_MANAGER = "warehouse_manager";
export const WAREHOUSE_LOGISTICS_DIRECTOR = "warehouse_logistics_director";

export const ROLES = [
  ADMIN,
  ACCOUNTING,
  QUALITY_CONTROL,
  SALES,
  WAREHOUSE,
  REPAIR
];

export const USER_ROLES = {
  [ACCOUNTING]: { label: "Accounting" },
  [ADMIN]: { label: "Admin" },
  [QUALITY_CONTROL]: { label: "Quality Control" },
  [REPAIR]: { label: "Repair" },
  [SALES]: { label: "Sales" },
  [WAREHOUSE]: { label: "Warehouse" }
};

export const SUBROLES_BY_ROLE = {
  [ACCOUNTING]: {
    [ACCOUNTING_ADMIN]: {
      label: subroleLabel(ACCOUNTING, ACCOUNTING_ADMIN)
    },
    [ACCOUNTING_MANAGER]: {
      label: subroleLabel(ACCOUNTING, ACCOUNTING_MANAGER)
    }
  },
  [QUALITY_CONTROL]: {
    [QUALITY_CONTROL_ADMIN]: {
      label: subroleLabel(QUALITY_CONTROL, QUALITY_CONTROL_ADMIN)
    },
    [QUALITY_CONTROL_MANAGER]: {
      label: subroleLabel(QUALITY_CONTROL, QUALITY_CONTROL_MANAGER)
    },
    [QUALITY_CONTROL_EXPEDITOR]: {
      label: subroleLabel(QUALITY_CONTROL, QUALITY_CONTROL_EXPEDITOR)
    }
  },
  [WAREHOUSE]: {
    [WAREHOUSE_BASIC]: {
      label: subroleLabel(WAREHOUSE, WAREHOUSE_BASIC)
    },
    [WAREHOUSE_EXPERT]: {
      label: subroleLabel(WAREHOUSE, WAREHOUSE_EXPERT)
    },
    [WAREHOUSE_MANAGER]: {
      label: subroleLabel(WAREHOUSE, WAREHOUSE_MANAGER)
    },
    [WAREHOUSE_LOGISTICS_DIRECTOR]: {
      label: subroleLabel(WAREHOUSE, WAREHOUSE_LOGISTICS_DIRECTOR)
    }
  },
  [PURCHASING]: {
    [PURCHASING_MANAGER]: {
      label: subroleLabel(PURCHASING, PURCHASING_MANAGER)
    }
  },
  [SALES]: {
    [SALES_MANAGER]: {
      label: subroleLabel(SALES, SALES_MANAGER)
    }
  }
};

export const SUBROLES = [
  ACCOUNTING_MANAGER,
  QUALITY_CONTROL_MANAGER,
  QUALITY_CONTROL_EXPEDITOR,
  QUALITY_CONTROL_ADMIN,
  WAREHOUSE_BASIC,
  WAREHOUSE_EXPERT,
  WAREHOUSE_MANAGER,
  WAREHOUSE_LOGISTICS_DIRECTOR
];

export const NOT_APPROVER = "not_approver";
export const RESIDENT_EXPERT_APPROVER = "resident_expert_approver";
export const APPROVER = "approver";
export const SUPER_APPROVER = "super_approver";

export const PO_APPROVAL_ROLES = {
  [NOT_APPROVER]: {
    label: "None"
  },
  [RESIDENT_EXPERT_APPROVER]: {
    label: "Resident Expert Approver (up to $50k)"
  },
  [APPROVER]: {
    label: "Standard Approver (up to $100k)"
  },
  [SUPER_APPROVER]: {
    label: "Super Approver ($100k+)"
  }
};

export const NOTIFICATION_ROLES_ARRAY = [
  ACCOUNTING_ADMIN,
  ACCOUNTING,
  ACCOUNTING_MANAGER,
  PURCHASING,
  PURCHASING_MANAGER,
  QUALITY_CONTROL,
  QUALITY_CONTROL_EXPEDITOR,
  QUALITY_CONTROL_ADMIN,
  QUALITY_CONTROL_MANAGER,
  REPAIR,
  SALES,
  SALES_MANAGER,
  WAREHOUSE,
  WAREHOUSE_BASIC,
  WAREHOUSE_EXPERT,
  WAREHOUSE_MANAGER,
  WAREHOUSE_LOGISTICS_DIRECTOR
];

export const CAN_ADD_UPDATE_APPLICATIONS = "can_add_update_applications";
export const CAN_ADD_UPDATE_PARTS = "can_add_update_parts";
export const CAN_EXPORT_COMPANIES = "can_export_companies";
export const CAN_MERGE_PART_NUMBERS = "can_merge_part_numbers";
export const CAN_RELEASE_QC_HOLD = "can_release_qc_hold";
export const CAN_VIEW_ACTIVE_PARTS = "can_view_active_parts";
export const CAN_RELEASE_EXPORT_COMPLIANCE_HOLD =
  "can_release_export_compliance_hold";
export const CAN_VIEW_ALL_COMMISSIONS = "can_view_all_commissions";
export const CAN_VIEW_ALL_INVENTORY = "can_view_all_inventory";
export const CAN_VIEW_INFOTRADER_SETTINGS = "can_view_infotrader_settings";
export const CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST =
  "can_view_update_all_reserved_for_sale_list";
export const RECEIVING = "receiving";
export const CREATE_POS = "create_pos";
export const CREATE_COC = "create_coc";
export const CREATE_COMMERCIAL_INVOICE = "create_commercial_invoice";
export const CREATE_PACKING_SLIP = "create_packing_slip";
export const CREATE_ROS = "create_ros";
export const CREATE_IQS_OQS = "create_iqs_oqs";
export const CREATE_VENDOR_RMAS = "create_vendor_rmas";

export const PERMISSIONS_ARRAY = [CAN_ADD_UPDATE_PARTS];

export const ROLES_WITHOUT_ADMIN_WH = removeItems(ROLES, ADMIN, WAREHOUSE);

export const ROLES_WITH_PERMISSION = {
  [ACCOUNTING]: [ACCOUNTING],
  [CAN_ADD_UPDATE_APPLICATIONS]: [QUALITY_CONTROL, SALES],
  [CAN_ADD_COMPANIES]: [QUALITY_CONTROL],
  [CAN_UPDATE_COMPANIES]: [QUALITY_CONTROL],
  [CAN_ADD_UPDATE_PARTS]: [SALES],
  [CAN_MERGE_PART_NUMBERS]: [],
  [CAN_RELEASE_ACCOUNTING_HOLD]: [ACCOUNTING],
  [CAN_RELEASE_EXPORT_COMPLIANCE_HOLD]: [QUALITY_CONTROL],
  [CAN_RELEASE_QC_HOLD]: [QUALITY_CONTROL],
  [CAN_VIEW_ACTIVE_PARTS]: [CAN_VIEW_ACTIVE_PARTS],
  [CAN_VIEW_ALL_INVENTORY]: [QUALITY_CONTROL, ACCOUNTING],
  [CREATE_COMMERCIAL_INVOICE]: [ADMIN],
  [CREATE_POS]: ROLES_WITHOUT_ADMIN_WH,
  [CREATE_VENDOR_RMAS]: ROLES_WITHOUT_ADMIN_WH,
  [CREATE_IQS_OQS]: [SALES, REPAIR],
  [QUALITY_CONTROL]: [QUALITY_CONTROL],
  [RECEIVING]: [QUALITY_CONTROL, WAREHOUSE, REPAIR],
  [CREATE_PACKING_SLIP]: [
    WAREHOUSE_MANAGER,
    WAREHOUSE_LOGISTICS_DIRECTOR,
    WAREHOUSE_EXPERT,
    QUALITY_CONTROL
  ],
  [CREATE_COC]: [QUALITY_CONTROL],
  [REPAIR]: [REPAIR],
  [SALES]: [SALES]
};

export const SUBROLES_WITH_PERMISSION = {
  [CREATE_PACKING_SLIP]: [
    WAREHOUSE_MANAGER,
    WAREHOUSE_LOGISTICS_DIRECTOR,
    WAREHOUSE_EXPERT
  ],
  [CAN_VIEW_ALL_COMMISSIONS]: [ACCOUNTING_ADMIN, ACCOUNTING_MANAGER],
  [CREATE_COMMERCIAL_INVOICE]: [
    WAREHOUSE_EXPERT,
    WAREHOUSE_MANAGER,
    WAREHOUSE_LOGISTICS_DIRECTOR
  ]
};

const PERMISSIONS_OPTIONS_UNSORTED = [
  CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS,
  CAN_EXPORT_COMPANIES,
  CAN_RELEASE_ACCOUNTING_HOLD,
  CAN_RELEASE_CORE_RETURN,
  CAN_MERGE_PART_NUMBERS,
  CAN_OVERRIDE_LISTING,
  ACCOUNTING,
  QUALITY_CONTROL,
  QUALITY_CONTROL_MANAGER,
  RECEIVING,
  WAREHOUSE_MANAGER
]
  .map(
    a =>
      arrayToManipulatedOptions([a], text =>
        properCase(text.replace("can_", ""))
      )[0]
  )
  .reduce(
    (agg, obj) => ({
      ...agg,
      [obj.value]: obj
    }),
    {
      [CAN_ADD_UPDATE_APPLICATIONS]: {
        value: CAN_ADD_UPDATE_APPLICATIONS,
        text: "Add / Update Applications"
      },
      [CAN_ADD_UPDATE_PARTS]: {
        value: CAN_ADD_UPDATE_PARTS,
        text: "Add / Update Parts"
      },
      [CAN_ADD_COMPANIES]: {
        value: CAN_ADD_COMPANIES,
        text: "Add Companies"
      },
      [CAN_UPDATE_COMPANIES]: {
        value: CAN_UPDATE_COMPANIES,
        text: "Update Companies"
      },
      [CAN_EDIT_DO_NOT_EXCHANGE]: {
        value: CAN_EDIT_DO_NOT_EXCHANGE,
        text: "Do Not Exchange"
      },
      [CAN_EXPORT_COMPANIES]: {
        value: CAN_EXPORT_COMPANIES,
        text: "Export Companies"
      },
      [CAN_VIEW_ALL_COMMISSIONS]: {
        value: CAN_VIEW_ALL_COMMISSIONS,
        text: "View All Commissions"
      },
      [CAN_VIEW_ALL_INVENTORY]: {
        value: CAN_VIEW_ALL_INVENTORY,
        text: "View All Inventory"
      },
      [CAN_VIEW_INFOTRADER_SETTINGS]: {
        value: CAN_VIEW_INFOTRADER_SETTINGS,
        text: "View InfoTrader Settings"
      },
      [CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST]: {
        value: CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST,
        text: "View / Update All Reserved For Sale List"
      },
      [CAN_RELEASE_QC_HOLD]: {
        value: CAN_RELEASE_QC_HOLD,
        text: "Release QC Hold"
      },
      [CAN_VIEW_ACTIVE_PARTS]: {
        value: CAN_VIEW_ACTIVE_PARTS,
        text: "View Active Parts / Sellable Qty"
      },
      [CREATE_IQS_OQS]: {
        value: CREATE_IQS_OQS,
        text: "Create IQs/OQs"
      },
      [CREATE_POS]: {
        value: CREATE_POS,
        text: "Create POs"
      },
      [CREATE_COC]: {
        value: CREATE_COC,
        text: "Create COC"
      },
      [CREATE_COMMERCIAL_INVOICE]: {
        value: CREATE_COMMERCIAL_INVOICE,
        text: "Create Commercial Invoice"
      },
      [CREATE_PACKING_SLIP]: {
        value: CREATE_PACKING_SLIP,
        text: "Create Packing Slip"
      },
      [CREATE_VENDOR_RMAS]: {
        value: CREATE_VENDOR_RMAS,
        text: "Create Vend RMAs"
      },
      [CAN_RELEASE_EXPORT_COMPLIANCE_HOLD]: {
        value: CAN_RELEASE_EXPORT_COMPLIANCE_HOLD,
        text: "Release Export Compliance Hold"
      },
      [REPAIR]: {
        value: REPAIRS,
        text: "Add / Update Repairs"
      },
      [SALES]: {
        value: SALES,
        text: "Add / Update Sales"
      }
    }
  );

export const PERMISSIONS_OPTIONS = Object.keys(PERMISSIONS_OPTIONS_UNSORTED)
  .sort((a, b) => {
    const nameA = PERMISSIONS_OPTIONS_UNSORTED[a].text;
    const nameB = PERMISSIONS_OPTIONS_UNSORTED[b].text;

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  })
  .reduce((obj, key) => {
    obj[key] = PERMISSIONS_OPTIONS_UNSORTED[key];
    return obj;
  }, {});



// WEBPACK FOOTER //
// ./app/modules/users/constants.js